import * as angular from "angular";
import {IController} from "angular";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";

export class ImportFileMappingPreviewComponent implements IController {
  schemaFields: any;
  previewRows: any;
  bringozFields: any[];
  isSchemaEditMode: boolean;
  onSchemaFieldsChange: Function;

  public excludedBringozFields: any[];
  public schemaFieldsOptionsWrapper: any;
  public schemaFieldsMap: {};

  constructor() {
  }

  $onInit() {
    // IF NEEDED
    // this.previewRows?.forEach((row) => {
    //   row.cellValues?.sort((a, b) => {
    //     return a.index - b.index;
    //   })
    // })

    if (this.bringozFields) {
      this.schemaFieldsOptionsWrapper = {
        list: this.bringozFields.map(bf => {
            return {id: bf.name, fieldType: bf.fieldType, isRequired: bf.required}
          }
        ),
        propertyRef: 'fieldType'
      };


    }
    this.setBringozFieldsData();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.schemaFields && !changes.schemaFields.isFirstChange() ||
      changes.previewRows && !changes.previewRows.isFirstChange()) {
      this.setBringozFieldsData();
    }

    if (changes.bringozFields && !changes.bringozFields.isFirstChange()) {
      if (this.bringozFields) {
        this.schemaFieldsOptionsWrapper = {
          list: this.bringozFields.map(bf => {
            return {id: bf.name, fieldType: bf.fieldType, isRequired: bf.required}
          }), propertyRef: 'fieldType'
        };
      }
      this.setBringozFieldsData();
    }
  }


  onSelectBringozField(value, index) {
    this.schemaFields[index].fieldType = value;

    if (!value) {
      this.schemaFields[index].defaultValue = undefined;
    }
    this.onSchemaFieldsChange({schemaFields: this.schemaFields});
  }

  onChangeDefaultValue(value, index) {
    this.schemaFields[index].defaultValue = value;
    this.onSchemaFieldsChange({schemaFields: this.schemaFields});
  }

  setEvents() {
    const headers = document.querySelectorAll("#import-file-mapping-preview .import-file-mapping-preview-header");
    const table = document.getElementById('import-file-mapping-preview').querySelectorAll('.md-virtual-repeat-scroller')[0];

    table.addEventListener('scroll', e => {
      headers.forEach(header => {
        header.scrollTop = table.scrollTop;
        header.scrollLeft = table.scrollLeft;
      });
    }, {passive: true})
  }

  private setBringozFieldsData() {
    this.excludedBringozFields = [];
    this.schemaFieldsMap = {};
    this.schemaFields?.forEach((sf, index) => {

      if (!!sf.fieldType) {
        this.excludedBringozFields.push(sf.fieldType);
      }
      this.schemaFieldsMap[sf.colIndex] = sf;
    })
  }

}

angular
  .module('bringoz.admin.commons')
  .component('importFileMappingPreview', {
    require: {
      form: '^form'
    },
    bindings: {
      schemaFields: '<',
      previewRows: '<',
      isSchemaEditMode: '<?',
      bringozFields: '<',
      onSchemaFieldsChange: '&'
    },
    templateUrl: 'app/modules/commons/components/import-file-mapping-preview/import-file-mapping-preview.html',
    controller: ImportFileMappingPreviewComponent
  });
